import { render } from "./sampleList.vue?vue&type=template&id=4a8518f5"
import script from "./sampleList.vue?vue&type=script&lang=js"
export * from "./sampleList.vue?vue&type=script&lang=js"

import "./sampleList.vue?vue&type=style&index=0&id=4a8518f5&lang=scss"
import "./sampleList.vue?vue&type=style&index=1&id=4a8518f5&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__